import { Box, Button, Stack, Typography } from '@mui/material'
import { useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import { updateModal } from '../../../store/common/common_action'
import { focusElemnt, getGSTNAddress, navigation2 } from '../../common/helper'
import * as iid from '../../common/bookingElementId'
import * as mdt from '../../common/modaltypes'
import Modal from '../../common/modal'
import { useTranslation } from '../../../i18n/I18nProvider'

const GstnValidationUI = (props) => {
  const { translations } = useTranslation()
  const au = translations?.adminUpdate || {}
  const gst = props?.gstnValidationData
  const gstd = gst?.data
  const buttonRef = useRef(null)
  useEffect(() => {
    buttonRef.current.focus()
  }, [])
  return (
    <Modal
      headTxt={au.gstinStatus || 'GSTIN Status'}
      width={'30%'}
      updateModal={() => {
        props.setGstnModal(false)
      }}
    >
      <Stack direction="column" sx={{ padding: '15px 0px' }} className="booking-confirmation-section">
        <Box sx={{ width: '100%', padding: '12px 15px' }} className="sender-receiver">
          <Box className="sr-row">
            <Typography className="sr-label" sx={{ alignItems: 'left' }}>
              {au.gstn || 'GSTN'}
            </Typography>
            :
            <Typography className="sr-value" sx={{ alignItems: 'left' }}>
              {gst?.GSTN}
            </Typography>
          </Box>
          <Box className="sr-row">
            <Typography className="sr-label" sx={{ alignItems: 'left' }}>
              {au.companyName || 'Company Name'}
            </Typography>
            :
            <Typography className="sr-value" sx={{ alignItems: 'left' }}>
              {gstd?.CompanyName}
            </Typography>
          </Box>
          <Box className="sr-row">
            <Typography className="sr-label" sx={{ alignItems: 'left' }}>
              {au.address || 'Address'}
            </Typography>
            :
            <Typography className="sr-value" style={{ alignItems: 'left', whiteSpace: 'initial' }}>
              {getGSTNAddress(gstd, translations?.common || {})}
            </Typography>
          </Box>
          <Box className="sr-row">
            <Typography className="sr-label" sx={{ alignItems: 'left' }}>
              {au.status || 'Status'}
            </Typography>
            :
            <Typography className="sr-value" sx={{ alignItems: 'left' }}>
              {gstd.Status}
            </Typography>
          </Box>
        </Box>
        <Box sx={{ width: '100%', padding: '12px 15px' }}>
          <Button
            ref={buttonRef}
            variant="contained"
            className="btn btn-primary"
            onClick={(e) => {
              props.setGstnModal(false)
              focusElemnt(props?.gstnValidationData?.navigation === 2 ? iid.destinationCity : iid.RecName)
            }}
            sx={{
              width: '100%',
            }}
          >
            {au.ok || 'Ok'}
          </Button>
        </Box>
      </Stack>
    </Modal>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = {}
export default connect(mapStateToProps, mapDispatchToProps)(GstnValidationUI)
